/* Copyright 2020 Enrico Ros. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import React from "react";
import Avatar from "@material-ui/core/Avatar";

import AwesomoIcon from "../icons/AwesomoIcon";
import {Brand, brandStyleKey} from "../Brand";
import {ChatIcon} from "./ChatIcon";

/**
 * Avatar version of the icon. Basically icon in a box.
 */
export function ChatIconAvatar({chatSnapshot, noShadow, noInlineStyle, className, onClick}: { chatSnapshot: StageTypes.ChatSnapshot | null, noShadow?: boolean, noInlineStyle?: boolean, className?: any, onClick?: any }) {
  const barStyle = brandStyleKey(chatSnapshot && chatSnapshot.theme);
  let inlineBarStyle = Brand.styles[barStyle];
  if (noShadow) delete inlineBarStyle['boxShadow'];
  if (noInlineStyle) inlineBarStyle = {};
  return (
    <Avatar variant="rounded" style={{...inlineBarStyle}} className={className} onClick={onClick}>
      <ChatIcon chatSnapshot={chatSnapshot} noStyle/>
    </Avatar>
  );
}

export function BrandIconAvatar(props) {
  return (
    <Avatar variant="rounded" {...props}>
      <AwesomoIcon/>
    </Avatar>
  )
}
